import React from 'react';
import { Link } from 'react-router-dom';
import './CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="cookie-policy">
      <div className="cookie-header">
        <h1>COOKIE POLICY</h1>
        <p>Last updated November 27, 2025</p>
      </div>
      
      <div className="cookie-content">
        <p>This Cookie Policy explains how <strong>ThanksLoop LLC</strong> ("<strong>we</strong>," "<strong>us</strong>," or "<strong>our</strong>") uses cookies and similar tracking technologies to recognize you when you visit our website at <a href="https://mazagift.com">mazagift.com</a> (the "<strong>Website</strong>"). It explains what these technologies are and why we use them, as well as your rights to control our use of them.</p>
        
        <p><strong>Questions or concerns?</strong> If you have any questions or concerns about our use of cookies or other technologies, please contact us at <a href="mailto:hello@mazagift.com">hello@mazagift.com</a>.</p>
        
        <h2>WHAT ARE COOKIES?</h2>
        <p>Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well as to provide reporting information.</p>
        
        <p>Cookies set by the website owner (in this case, ThanksLoop LLC) are called "first-party cookies." Cookies set by parties other than the website owner are called "third-party cookies." Third-party cookies enable third-party features or functionality to be provided on or through the website (e.g., advertising, interactive content, and analytics). The parties that set these third-party cookies can recognize your computer both when it visits the website in question and also when it visits certain other websites.</p>
        
        <h2>WHY DO WE USE COOKIES?</h2>
        <p>We use first-party and third-party cookies for several reasons:</p>
        <ul>
          <li><strong>Essential cookies:</strong> These cookies are required to provide you with services available through our Website and to use some of its features, such as access to secure areas.</li>
          <li><strong>Performance and functionality cookies:</strong> These cookies are used to enhance the performance and functionality of our Website but are non-essential to their use. However, without these cookies, certain functionality may become unavailable.</li>
          <li><strong>Analytics and customization cookies:</strong> These cookies collect information that is used either in aggregate form to help us understand how our Website is being used or how effective our marketing campaigns are, or to help us customize our Website for you.</li>
          <li><strong>Advertising cookies:</strong> These cookies are used to make advertising messages more relevant to you. They also perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed for advertisers, and in some cases selecting advertisements that are based on your interests.</li>
          <li><strong>Social networking cookies:</strong> These cookies are used to enable you to share pages and content that you find interesting on our Website through third-party social networking and other websites. These cookies may also be used for advertising purposes.</li>
        </ul>
        
        <h2 id="whatcookies">WHAT COOKIES DO WE USE?</h2>
        <p>Below is a detailed list of the cookies we use on our Website. We've endeavored to ensure that your cookie information is complete and accurate as of this document's date. However, please note that cookie names and purposes may change over time.</p>
        
        <h3>Essential Website Cookies</h3>
        <p>These cookies are strictly necessary to provide you with services available through our Website and to use some of its features, such as access to secure areas.</p>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Cookie Name</th>
                <th>Purpose</th>
                <th>Duration</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>session_id</td>
                <td>Maintains your session state and security</td>
                <td>Session</td>
                <td>First-party</td>
              </tr>
              <tr>
                <td>csrf_token</td>
                <td>Protects against cross-site request forgery attacks</td>
                <td>Session</td>
                <td>First-party</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h3>Performance and Analytics Cookies</h3>
        <p>These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our Website. They help us to know which pages are the most and least popular and see how visitors move around the Website. All information these cookies collect is aggregated and therefore anonymous.</p>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Cookie Name</th>
                <th>Purpose</th>
                <th>Duration</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>_ga</td>
                <td>Google Analytics - Used to distinguish users</td>
                <td>2 years</td>
                <td>Third-party</td>
              </tr>
              <tr>
                <td>_gid</td>
                <td>Google Analytics - Used to distinguish users</td>
                <td>24 hours</td>
                <td>Third-party</td>
              </tr>
              <tr>
                <td>_gat</td>
                <td>Google Analytics - Used to throttle request rate</td>
                <td>1 minute</td>
                <td>Third-party</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h3>Functionality Cookies</h3>
        <p>These cookies enable the Website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.</p>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Cookie Name</th>
                <th>Purpose</th>
                <th>Duration</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>preferences</td>
                <td>Stores your website preferences and settings</td>
                <td>1 year</td>
                <td>First-party</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h2 id="othertracking">WHAT ABOUT OTHER TRACKING TECHNOLOGIES?</h2>
        <p>Cookies are not the only way to recognize or track visitors to a website. We may use other, similar technologies from time to time, like web beacons (sometimes called "tracking pixels" or "clear gifs"). These are tiny graphics files that contain a unique identifier that enables us to recognize when someone has visited our Website or opened an email that we have sent them.</p>
        
        <p>This allows us, for example, to monitor the traffic patterns of users from one page within our Website to another, to deliver or communicate with cookies, to understand whether you have come to our Website from an online advertisement displayed on a third-party website, to improve site performance, and to measure the success of email marketing campaigns. In many instances, these technologies are reliant on cookies to function properly, and so declining cookies will impair their functioning.</p>
        
        <p>We may also use Local Storage Objects (LSOs) such as HTML5 to store content information and preferences. Various browsers may offer their own management tools for removing HTML5 LSOs. Similar to other cookies, you can block HTML5, but then you may not be able to use certain features on our Website.</p>
        
        <h2 id="thirdparty">DO YOU USE FLASH COOKIES OR LOCAL STORAGE?</h2>
        <p>We may use Flash cookies (also known as Local Shared Objects or "LSOs") to store your preferences or display content based upon what you view on our Website to personalize your visit. Unlike regular cookies, Flash cookies cannot be removed or blocked via your browser settings; however, they can be removed by following directions provided in Adobe's website at <a href="https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html" target="_blank" rel="noopener noreferrer">https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html</a>.</p>
        
        <p>We may also use other similar technologies like Local Storage to store preferences and information on your device. You can manage these through your browser settings.</p>
        
        <h2 id="do-not-track">DO YOU USE SESSION REPLAY OR RECORDING?</h2>
        <p>We may use third-party session replay and recording services to understand how users interact with our Website. These services may record your interactions with our Website, including mouse movements, clicks, keystrokes, and other user actions, as well as the pages you visit and the content you view. This information helps us improve our Website's usability and user experience.</p>
        
        <p>Session replay recordings may include personal information that you provide during your session. We use this information solely for the purpose of improving our Website and services.</p>
        
        <h2>HOW CAN YOU CONTROL COOKIES?</h2>
        <p>You have the right to decide whether to accept or reject cookies. You can exercise your cookie rights by setting your preferences in the Cookie Consent Manager. The Cookie Consent Manager allows you to select which categories of cookies you accept or reject. Essential cookies cannot be rejected as they are strictly necessary to provide you with services.</p>
        
        <p>The Cookie Consent Manager can be found in the notification banner and on our Website. If you choose to reject cookies, you may still use our Website though your access to some functionality and areas of our Website may be restricted. You may also set or amend your web browser controls to accept or refuse cookies.</p>
        
        <p>If you choose to reject cookies, you may still use our Website though your access to some functionality and areas of our Website may be restricted. As the means by which you can refuse cookies through your web browser controls vary from browser to browser, you should visit your browser's help menu for more information.</p>
        
        <h3>Browser Controls</h3>
        <p>Most web browsers allow you to control cookies through their settings preferences. However, limiting cookies may impact your experience using our Website. The following links provide information on how to modify the cookies settings on some popular browsers:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
          <li><a href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
          <li><a href="https://support.microsoft.com/en-us/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          <li><a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank" rel="noopener noreferrer">Opera</a></li>
        </ul>
        
        <h3>Mobile Device Controls</h3>
        <p>Mobile devices may also allow you to control cookies through their settings. Please refer to your mobile device manufacturer's instructions for more information on how to manage cookies on mobile devices.</p>
        
        <h2 id="optout">HOW TO OPT OUT OF INTEREST-BASED ADVERTISING</h2>
        <p>Some third parties may use cookies or other technologies to deliver advertising on our Website tailored to your interests. You can opt out of receiving targeted advertising from certain providers by visiting:</p>
        <ul>
          <li><strong>Digital Advertising Alliance:</strong> <a href="https://youradchoices.com/" target="_blank" rel="noopener noreferrer">https://youradchoices.com/</a></li>
          <li><strong>Network Advertising Initiative:</strong> <a href="https://www.networkadvertising.org/choices/" target="_blank" rel="noopener noreferrer">https://www.networkadvertising.org/choices/</a></li>
          <li><strong>European Interactive Digital Advertising Alliance:</strong> <a href="https://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer">https://www.youronlinechoices.eu/</a></li>
        </ul>
        
        <p>Please note that opting out does not prevent all advertising. You may still see advertisements that are not tailored to your interests.</p>
        
        <h2 id="specific-info">COOKIE-SPECIFIC INFORMATION</h2>
        <p>We use cookies and similar tracking technologies (like web beacons and pixels) to gather information when you interact with our Website. Some online tracking technologies help us maintain the security of our Website and your account, prevent crashes, fix bugs, save your preferences, and assist with basic site functions.</p>
        
        <p>We also permit third parties and service providers to use online tracking technologies on our Website for analytics and advertising, including to help manage and display advertisements, to tailor advertisements to your interests, or to send abandoned shopping cart reminders (depending on your communication preferences). The third parties and service providers use their technology to provide advertising about products and services tailored to your interests which may appear either on our Website or on other websites.</p>
        
        <h2 id="us-states">YOUR RIGHTS REGARDING COOKIES</h2>
        <p>Depending on where you are located geographically, applicable privacy laws may provide you with certain rights regarding the use of cookies and similar tracking technologies. These rights may include:</p>
        <ul>
          <li>The right to be informed about the use of cookies and similar technologies</li>
          <li>The right to opt out of non-essential cookies</li>
          <li>The right to access information about cookies used on our Website</li>
          <li>The right to withdraw consent for cookie use</li>
        </ul>
        
        <p>To the extent these online tracking technologies are deemed to be a "sale"/"sharing" (which includes targeted advertising, as defined under the applicable laws) under applicable US state laws, you can opt out of these online tracking technologies by submitting a request as described in our <Link to="/privacy-policy">Privacy Policy</Link> under the section "DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?"</p>
        
        <h2 id="updates">UPDATES TO THIS COOKIE POLICY</h2>
        <p>We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal, or regulatory reasons. Please therefore revisit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.</p>
        
        <p>The date at the top of this Cookie Policy indicates when it was last updated.</p>
        
        <h2 id="contact">HOW CAN YOU CONTACT US ABOUT THIS COOKIE POLICY?</h2>
        <p>If you have questions or comments about this Cookie Policy, you may email us at <a href="mailto:hello@mazagift.com">hello@mazagift.com</a> or contact us by post at:</p>
        <p>
          ThanksLoop LLC<br />
          18 SOUTH 2ND STREET<br />
          San Jose, CA 95113<br />
          United States
        </p>
        
        <h2>RELATED DOCUMENTATION</h2>
        <p>For more information about how we process your personal information, please review our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
        
        <div className="cookie-footer">
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;

